import React, { memo } from "react";

import { ShowcaseStageProps } from "./types";

/**
 * Pozornica za lebdeće kartice stalne veličine. Kartice (ShowcaseCard) se unutar nje postavljaju
 * apsolutno, a nagib nosi svaka kartica sama — vidi ShowcaseCard.
 */
const ShowcaseStage: React.FC<ShowcaseStageProps> = ({ children }) => {
  return (
    <div className="relative w-[30rem] h-[22rem]">
      {children}
    </div>
  );
};

export default memo(ShowcaseStage);
